// src/Pages/Dashboard/Sidebar.jsx
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Dashboard.css";

export default function Sidebar({ sidebarOpen = false }) {
  const profile = JSON.parse(localStorage.getItem("profile") || "{}");
  const navigate = useNavigate();
  const location = useLocation();

  const [salesOpen, setSalesOpen] = useState(false);
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token || Object.keys(profile).length === 0) {
      navigate("/", { replace: true });
    }
  }, [navigate, profile]);

  const toggleSales = () => setSalesOpen(!salesOpen);
  const togglePurchase = () => setPurchaseOpen(!purchaseOpen);
  const toggleSettings = () => setSettingsOpen(!settingsOpen);

  const isActive = (paths) => {
    return paths.some((path) => location.pathname.startsWith(path));
  };

  const salesPaths = [
    "/sales/customers",
    "/sales/quotes",
    "/sales/sales-orders",
    "/sales/invoices",
    "/sales/recurring-invoices",
    "/sales/delivery-challans",
    "/sales/payments-received",
    "/sales/credit-notes",
  ];

  const purchasePaths = [
    "/purchase/vendors",
    "/purchase/expenses",
    "/purchase/purchase-orders",
    "/purchase/bills",
  ];

  return (
    <aside className={`dashboard-sidebar ${sidebarOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <h2>Finance</h2>
      </div>

      <nav className="sidebar-nav">
        <ul>
          <li>
            <Link
              to="/dashboard"
              className={`nav-link ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              <span className="icon">🏠</span> Dashboard
            </Link>
          </li>

          <li>
            <div
              className={`dropdown-header ${salesOpen ? "open" : ""} ${
                isActive(salesPaths) ? "active" : ""
              }`}
              onClick={toggleSales}
            >
              <span className="icon">📦</span> Sales
            </div>
            <ul className={`dropdown-menu ${salesOpen ? "open" : ""}`}>
              <li>
                <Link to="/sales/customers">Customers</Link>
              </li>
              <li>
                <Link to="/sales/quotes">Quotes</Link>
              </li>
              <li>
                <Link to="/sales/sales-orders">Sales Orders</Link>
              </li>
              <li>
                <Link to="/sales/invoices">Invoices</Link>
              </li>
              <li>
                <Link to="/sales/recurring-invoices">Recurring Invoices</Link>
              </li>
              <li>
                <Link to="/sales/delivery-challans">Delivery Challans</Link>
              </li>
              <li>
                <Link to="/sales/payments-received">Payments Received</Link>
              </li>
              <li>
                <Link to="/sales/credit-notes">Credit Notes</Link>
              </li>
            </ul>
          </li>

          <li>
            <div
              className={`dropdown-header ${purchaseOpen ? "open" : ""} ${
                isActive(purchasePaths) ? "active" : ""
              }`}
              onClick={togglePurchase}
            >
              <span className="icon">🛒</span> Purchase
            </div>
            <ul className={`dropdown-menu ${purchaseOpen ? "open" : ""}`}>
              <li>
                <Link to="/purchase/vendors">Vendors</Link>
              </li>
              <li>
                <Link to="/purchase/expenses">Expenses</Link>
              </li>
              <li>
                <Link to="/purchase/purchase-orders">Purchase Orders</Link>
              </li>
              <li>
                <Link to="/purchase/bills">Bills</Link>
              </li>
            </ul>
          </li>

          <li>
            <div
              className={`dropdown-header ${settingsOpen ? "open" : ""} ${
                location.pathname.startsWith("/settings") ? "active" : ""
              }`}
              onClick={toggleSettings}
            >
              <span className="icon">⚙️</span> Settings
            </div>
            <ul className={`dropdown-menu ${settingsOpen ? "open" : ""}`}>
              <li>
                <Link to="/settings/organization">Organization</Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <p className="user-name">{profile.displayName || "User"}</p>
          <p className="user-email">
            {profile.mail || profile.userPrincipalName || "sample@example.com"}
          </p>
        </div>
        <button
          onClick={() => {
            window.location.href = "/logout";
          }}
          className="logout-btn"
        >
          Logout
        </button>
      </div>
    </aside>
  );
}
